"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DARK_ELEVATIONS", {
  enumerable: true,
  get: function () {
    return _elevation2.DARK_ELEVATIONS;
  }
});
Object.defineProperty(exports, "LIGHT_ELEVATIONS", {
  enumerable: true,
  get: function () {
    return _elevation2.LIGHT_ELEVATIONS;
  }
});
Object.defineProperty(exports, "elevation", {
  enumerable: true,
  get: function () {
    return _elevation.default;
  }
});

var _elevation = _interopRequireDefault(require("./elevation"));

var _elevation2 = require("./elevation.consts");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RoZW1lL2VsZXZhdGlvbi9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IGFzIGVsZXZhdGlvbiB9IGZyb20gJy4vZWxldmF0aW9uJ1xuZXhwb3J0IHsgREFSS19FTEVWQVRJT05TLCBMSUdIVF9FTEVWQVRJT05TIH0gZnJvbSAnLi9lbGV2YXRpb24uY29uc3RzJ1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBIn0=